module.exports = __webpack_public_path__ + "static/media/youtube.840d65a1.svg";